'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthEmailString = (_dec = (0, _reactRedux.connect)(null, (0, _extends3.default)({}, authActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AuthEmailString, _Component);

  function AuthEmailString() {
    (0, _classCallCheck3.default)(this, AuthEmailString);
    return (0, _possibleConstructorReturn3.default)(this, (AuthEmailString.__proto__ || (0, _getPrototypeOf2.default)(AuthEmailString)).apply(this, arguments));
  }

  (0, _createClass3.default)(AuthEmailString, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          removeLoginData = _props.removeLoginData,
          className = _props.className,
          email = _props.email;


      return _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'span',
          null,
          email
        ),
        _react2.default.createElement(
          'span',
          { className: 'a margin-left-5', onClick: removeLoginData },
          t('change user')
        )
      );
    }
  }]);
  return AuthEmailString;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  email: _propTypes2.default.string,
  removeLoginData: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp)) || _class) || _class);
exports.default = AuthEmailString;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/AuthEmailString.js
// module id = 1952
// module chunks = 1